import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'caststringarray' })
export class CastStringArrayPipe implements PipeTransform {
  transform(n: any): string[] { return n as string[]; }
}
